<script setup lang="ts">
import {
  IonAlert,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonSkeletonText,
  IonCardSubtitle,
  IonCardContent,
  IonIcon,
} from "@ionic/vue";
import {
  trash,
} from "ionicons/icons";
import { IEventV2 } from "@/models/event";
import { PropType, ref } from "vue";
import { deleteEvent } from "@/api/events";
import { handleError } from "@/views";
import router from "@/router";
import { useUserStore } from "@/stores/user";
import { useToasters } from "@/composition/toasters";
import useDates from "@/composition/dates";

const props = defineProps({
  event: Object as PropType<IEventV2>,
  route: String,
  loading: Boolean,
});

const userStore = useUserStore();
const toasters = useToasters();

const dates = useDates();

const deleteEventById = (event_id: number) => {
  deleteEvent(event_id)
    .then(() => {
      router.push("/home");
      toasters.addSuccess("Event deleted successfully");
      userStore.fetchMe();
      userStore.fetchRoles();
    })
    .catch((err) => {
      if (err.response.data && err.response.data[0]) {
        toasters.addError(err.response.data[0]);
      } else {
        handleError(err);
      }
    });
}

const deleteButtons = [
  {
    text: "Cancel",
    role: "cancel",
    cssClass: "alert-button-cancel",
    handler: () => {
      alertEvent.value = false;
    },
  },
  {
    text: " OK ",
    role: "confirm",
    cssClass: "alert-button-confirm",
    handler: () => {
      alertEvent.value = false;
      deleteEventById(props.event.id);
    },
  },
];

const alertEvent = ref(false);
</script>
<template>
  <ion-card class="event-card" :router-link="route || ''">
    <template v-if="event">
      <img class="event-image" alt="Event image" :src="event.image" v-if="event.image && event.image !== ''" />
      <img class="event-image" alt="Event image" src="@/assets/background.png" v-else />

      <ion-card-header>
        <ion-card-title class="ion-margin-bottom">
          {{ event.name }}
          <ion-icon :icon="trash" color="black" class="ion-float-right delete-event"
            @click="alertEvent = true"></ion-icon>
          <ion-alert :isOpen="alertEvent" :buttons="deleteButtons" header="Are you sure?"
            message="This will permanently delete your event." class="alert_delete_event"></ion-alert>
        </ion-card-title>
        <ion-card-subtitle>
          {{ dates.getDateWithTime(event.start_date) }} -
          {{ dates.getDateWithTime(event.end_date) }}
        </ion-card-subtitle>
      </ion-card-header>

      <ion-card-content v-if="event.location">
        <p>{{ event.location }}</p>
      </ion-card-content>
    </template>
    <template v-if="!event">
      <ion-skeleton-text :animated="true"></ion-skeleton-text>

      <ion-card-header>
        <ion-card-subtitle>
          <ion-skeleton-text :animated="true"></ion-skeleton-text>
        </ion-card-subtitle>
        <ion-card-title>
          <ion-skeleton-text :animated="true"></ion-skeleton-text>
        </ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <ion-skeleton-text :animated="true"></ion-skeleton-text>
      </ion-card-content>
    </template>
  </ion-card>
</template>

<style lang="scss" scoped>
.event-card {
  cursor: pointer;

}

.event-image {
  height: 200px;
  width: 100%;
  object-fit: cover;
}

@media (min-width: 768px) {
  .event-card {
    width: calc(50% - 15px);
  }

  .event-image {
    height: 300px;
  }
}

.delete-event {
  z-index: 999999;
}

ion-alert.alert_delete_event {
  --backdrop-opacity: 0.9 !important;
}
</style>
